export default "__VITE_ASSET__d8327156__"